import React, { useState, useEffect } from "react";

import { format } from "date-fns";
import { parseISO } from "date-fns/esm";
import { apiSpecialEvent } from "../../services/data";
import SpecialEventStatus from "../../utils/PopoverMessages";

import { Container } from "../../styles-components/Container";
import { ButtonA } from "../../styles-components/Buttons";
import {
  Actions,
  Company,
  History,
  Historys,
  ItemsConfig,
  Wrapper,
} from "./styles";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import Badge from "../Badge";
import LoadingEffect from "../LoadingEffect";
import Popover from "../Popover";
import { toast } from "react-toastify";

const SpecialEventShow = ({ id, setId, updateData, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [event, setEvent] = useState({});

  async function fetchSpecialEvent(id) {
    await apiSpecialEvent.show(id).then((response) => {
      setEvent(response.data);
      setIsLoading(false);
    });
  }

  const handleAccept = async (id) => {
    if (confirm("Deseja realmente aceitar está proposta?")) {
      await apiSpecialEvent
        .update(id, { only_status: true, status: "aprovado" })
        .then(() => {
          toast.success("Proposta aprovada!");
          updateData();
          setId(0);
          onClose();
        })
        .catch(() => toast.error("Algo deu errado entre você é o servidor!"));
    }
  };

  const handleRejectedPropose = async (id) => {
    if (confirm("Deseja realmente rejeitar está proposta?")) {
      await apiSpecialEvent
        .update(id, { only_status: true, status: "recusado" })
        .then(() => {
          toast.success("Proposta recusada!");
          updateData();
          setId(0);
          onClose();
        })
        .catch(() => toast.error("Algo deu errado entre você é o servidor!"));
    }
  };

  const handleCancelEvent = async (id) => {
    if (
      confirm(
        "Deseja cancelar este evento especial? Ele não poderá receber novas propostas e ficará inativo para edições"
      )
    ) {
      await apiSpecialEvent
        .update(id, { only_status: true, status: "cancelado" })
        .then(() => {
          toast.success("Evento cancelado!");
          updateData();
          setId(0);
          onClose();
        })
        .catch(() => toast.error("Algo deu errado entre você é o servidor!"));
    }
  };

  useEffect(() => {
    if (id > 0) {
      setIsLoading(true);
      fetchSpecialEvent(id);
    }
  }, [id]);

  return (
    <>
      {isLoading ? (
        <LoadingEffect />
      ) : (
        <Container>
          <Wrapper>
            <h3>{event.title}</h3>
            <Company style={{ fontStyle: "italic", marginBottom: "10px" }}>
              {event.client.nome_fantasia}
            </Company>
            <div>
              <p>Status: </p>
              <Popover
                text={SpecialEventStatus(event.status)}
                direction="row-reverse"
                icon={<AiOutlineQuestionCircle style={{ marginLeft: "5px" }} />}
              >
                <Badge
                  style={{ fontSize: "0.7rem", marginLeft: "5px" }}
                  type={event.badge}
                >
                  {event.status}
                </Badge>
              </Popover>
            </div>
            <p>Requisição realizada por: {event.creator.name}</p>
            <p>
              Data para realização: {format(parseISO(event.data), "d/MM/y")}
            </p>
            <p>Local para realização: {event.place}</p>

            {event.replace_meal.length > 0 ? (
              <>
                <p>
                  Este evento solicitou a substituição destas refeições:{" "}
                  {event.replace_meal.map((item, index) => (
                    <span
                      style={{ textTransform: "capitalize" }}
                      key={
                        Math.floor(Math.random() * 1000 + 1) +
                        item.produto_servico.nome
                      }
                    >
                      {item.produto_servico.nome.toLowerCase()}
                      {index + 1 !== event.replace_meal.length && ", "}
                    </span>
                  ))}
                </p>
                {event.has_addition === 1 && (
                  <p>Esse evento solicitou valor adicional</p>
                )}
              </>
            ) : (
              <p>Este evento não solicitou a substituição de refeições</p>
            )}
            {event.status !== "Análise" && event.confirm_deadline && (
              <>
                <p>
                  Prazo de pagamento:{" "}
                  {format(parseISO(event.payment_term), "d/MM/y")}
                </p>
                <p>
                  Prazo de confirmação:{" "}
                  {format(parseISO(event.confirm_deadline), "d/MM/y")}
                </p>
                <p>
                  Valor unitário:{" "}
                  {event.unitary_value.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                  })}
                </p>
                {event.has_addition === 1 && (
                  <p>
                    Valor adicional:{" "}
                    {event.addition_value.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                      minimumFractionDigits: 2,
                    })}
                  </p>
                )}
                <p>
                  Valot total:{" "}
                  {event.total_value.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                  })}
                </p>
                <p>
                  {event.has_service_selected ? (
                    `NCM para faturamento: ${event.service_selected.produto_servico.ncm} | ${event.service_selected.produto_servico.nome}`
                  ) : (
                    <>
                      Opções de NCM a definir por uma:
                      {event.services.map((service) => (
                        <React.Fragment key={service.produto_servico.nome}>
                          <br />
                          <span style={{ fontSize: "0.9rem" }}>
                            {service.produto_servico.ncm +
                              " | " +
                              service.produto_servico.nome}
                          </span>
                        </React.Fragment>
                      ))}
                    </>
                  )}
                </p>
              </>
            )}
            {!event.can_propose && event.status === "proposta" && (
              <Actions>
                <ButtonA type="button" onClick={() => handleAccept(id)}>
                  Aceitar proposta
                </ButtonA>
                <ButtonA
                  type="button"
                  onClick={() => handleRejectedPropose(id)}
                >
                  Recusar proposta
                </ButtonA>
                <ButtonA type="button" onClick={() => handleCancelEvent(id)}>
                  Recusar proposta e encerrar negociação
                </ButtonA>
              </Actions>
            )}
            <ItemsConfig>
              <h4>Informações do evento</h4>
              {event.configs.map((config) => (
                <div key={config.id + Math.floor(Math.random() * 1000 + 1)}>
                  <p>
                    <b>{config.title}</b>
                  </p>
                  <p>
                    {config.description
                      .split("\n")
                      .filter((linha) => linha.trim())
                      .map((linha, i) => (
                        <React.Fragment
                          key={i + Math.floor(Math.random() * 1000 + 1)}
                        >
                          {linha}
                          <br />
                        </React.Fragment>
                      ))}
                  </p>
                </div>
              ))}
            </ItemsConfig>
            {event.historys.length > 0 && (
              <Historys>
                <h4>Histórico de alterações</h4>
                {event.historys.reverse().map((history) => (
                  <History
                    color={event.history_color}
                    header={format(parseISO(history.created_at), "d/MM/yy")}
                    key={history.id + Math.floor(Math.random() * 1000 + 1)}
                  >
                    <div>
                      <h5>{history.title}</h5>
                      <p>{history.description}</p>
                    </div>
                  </History>
                ))}
              </Historys>
            )}
          </Wrapper>
        </Container>
      )}
    </>
  );
};

export default SpecialEventShow;
